<template>
  <div>
    <spinner-round v-if="!fromCard && loading"
      :is-loading="loading" :spinnerStyle="{top: '160px'}"></spinner-round>
    <div id="lots-tableau" class="" v-else>
      <div class="column is-narrow is-border-right is-border-left is-padding-top-small is-padding-bottom-small has-bg-white" v-if="!fromCard">
        <label class="checkbox checkRadioIsHide is-padding-right-xsmall" :for="s.value" v-for="s in profilAvailableStatus" :key="s.value">
          <input type="checkbox" :id="s.value" v-model="lotFilters" @click="updateStatus" :value="s.value">
          <span class="tag" :class="tagColor(s.value)">
            <span>{{s.label}}</span>
            <span class="icon"><i class="far" :class="lotFilters && lotFilters.includes(s.value) ? 'fa-check-square' : 'fa-square'"></i></span>
          </span>
        </label>
      </div>
      <div class="column is-narrow is-padding-top-small is-padding-bottom-small columns is-gapless is-vcentered" v-else>
        <div class="column is-narrow is-margin-right-small is-size-6" :for="s.value" v-for="s in profilAvailableStatus" :key="s.value">
          <span class="dot is-inline-block is-vcentered is-small" :class="bgColor(s.value)"></span>
          <span>{{s.label}}</span>
        </div>
      </div>
      <div v-show="items.length" :class="fromCard ? 'is-border-top' : 'is-border'"  :style="loading ? 'opacity: 0.4; cursor: wait' : ''">
        <div>
          <table-h-scroll :has-sticky="true" :sticky-styles="stickyStyles"
                          :sticky-datas="stickyDatas" :reload-controls="items">
            <table class="table is-fullwidth is-narrow is-striped-v is-first-fixed-small is-last-fixed-small is-marginless-bottom has-actionsontd">
              <thead>
                <tr class="is-size-6">
                  <th class="is-paddingless has-text-centered actions" style="z-index: 2;">
                    <div v-if="!multiselection"
                      class="dropdown is-hoverable is-left">
                      <div class="dropdown-trigger">
                        <button class="button is-circle is-small" aria-haspopup="true" aria-controls="dropdown-menu">
                          <i class="fal fa-cog"></i>
                        </button>
                      </div>
                      <columns-toggles :entries="columnsList" :source="columns" @update="updateColumns"></columns-toggles>
                    </div>
                    <button v-else class="button is-small is-light is-circle" @click="$emit('selectItemToggleAll', items)">
                      <span class="icon"><i class="far fa-check-double"></i></span>
                    </button>
                  </th>
                  <th class="col-ref is-groupcols-1a">
                    <sortable @sort="sort('ref', $event, sortBy)" :sort="sortBy.ref" label="Lot"></sortable>
                    <div class="deco"></div>
                  </th>
                  <th v-if="showColumn('program')" class="is-groupcols-1a">
                    <sortable v-if="!fromCard" @sort="sort('program_name', $event, sortBy)" :sort="sortBy.program_name" label="Programme"></sortable>
                    {{fromCard ? 'Programme' : ''}}
                    <div class="deco"></div>
                  </th>
                  <th v-if="isDistributeurMode && showColumn('promoteur_name') && !isExternal" class="is-groupcols-1a">
                    <sortable v-if="!fromCard" @sort="sort('promoteur_name', $event, sortBy)" :sort="sortBy.promoteur_name"
                              label="Promoteur"></sortable>
                    {{fromCard ? 'Promoteur' : ''}}
                    <div class="deco"></div>
                  </th>
                  <th v-if="showColumn('zip_code')" class="is-groupcols-1a">
                    <sortable v-if="!fromCard" @sort="sort('address.zip_code', $event, sortBy)" :sort="sortBy['address.zip_code']" label="Code Postal"></sortable>
                    {{fromCard ? 'Code Postal' : ''}}
                    <div class="deco"></div>
                  </th>
                  <th v-if="showColumn('city')" class="is-groupcols-1a">
                    <sortable v-if="!fromCard" @sort="sort('address.city', $event, sortBy)" :sort="sortBy['address.city']" label="Ville"></sortable>
                    {{fromCard ? 'Ville' : ''}}
                    <div class="deco"></div>
                  </th>
                  <th v-if="showColumn('nature')" class="is-groupcols-1a">
                    <sortable @sort="sort('nature', $event, sortBy)" :sort="sortBy.nature" label="Nature"></sortable>
                    <div class="deco"></div>
                  </th>
                  <th class="is-groupcols-1a" v-if="!isParking">
                    <sortable @sort="sort('lot_type', $event, sortBy)" :sort="sortBy.lot_type" label="Type"></sortable>
                    <div class="deco"></div>
                  </th>
                  <th v-if="showColumn('surface') && !isParking" class="is-groupcols-1a">
                    <sortable @sort="sort('surface', $event, sortBy)" :sort="sortBy.surface" label="Surface"></sortable>
                    <div class="deco"></div>
                  </th>
                  <th v-if="showColumn('floor') && !isParking" class="is-groupcols-1a">
                    <sortable @sort="sort('floor', $event, sortBy)" :sort="sortBy.floor" label="Étage"></sortable>
                    <div class="deco"></div>
                  </th>
                  <th v-if="showColumn('exposures') && !isParking" class="is-groupcols-1a">
                    Orientation
                    <div class="deco"></div>
                  </th>
                  <th v-if="showColumn('parking') && !isParking" class="is-groupcols-1a">
                    <sortable @sort="sort('parking_count', $event, sortBy)" :sort="sortBy.parking_count" label="Parking"></sortable>
                    <div class="deco"></div>
                  </th>
                  <th class="is-groupcols-2a">
                    <sortable @sort="sort('sale_price', $event, sortBy)" :sort="sortBy.sale_price"
                              label="Prix de Vente"></sortable>
                    <div class="deco"></div>
                  </th>
                  <th v-if="showColumn('rent') && !isParking" class="is-groupcols-2a">
                    <sortable @sort="sort('rent', $event, sortBy)" :sort="sortBy.rent" label="Loyer HC"></sortable>
                    <div class="deco"></div>
                  </th>
                  <th v-if="showColumn('tax_dispositifs') && !isParking" class="is-groupcols-2a">
                    <sortable @sort="sort('tax_dispositifs', $event, sortBy)" :sort="sortBy.tax_dispositifs"
                              label="Dispositif(s)"></sortable>
                    <div class="deco"></div>
                  </th>
                  <th v-if="showColumn('profitability') && !isParking" class="is-groupcols-2a">
                    <sortable @sort="sort('profitability', $event, sortBy)" :sort="sortBy.profitability"
                              label="Rentabilité">
                    </sortable>
                    <div class="deco"></div>
                  </th>
                  <th v-if="showColumn('capped_profitability') && !isParking" class="is-groupcols-2a">
                    <sortable @sort="sort('capped_profitability', $event, sortBy)" :sort="sortBy.capped_profitability"
                              label="Rentabilité plafonnée">
                    </sortable>
                    <div class="deco"></div>
                  </th>
                  <th v-if="showColumn('date_livraison')" class="is-groupcols-3a">
                    <sortable v-if="!fromCard" @sort="sort('date_livraison', $event, sortBy)" :sort="sortBy.date_livraison"
                              label="Livraison">
                    </sortable>
                    {{fromCard ? 'Livraison' : ''}}
                    <div class="deco"></div>
                  </th>
                  <th v-if="showColumn('date_actabilite')" class="is-groupcols-3a">
                    <sortable v-if="!fromCard" @sort="sort('date_actabilite', $event, sortBy)" :sort="sortBy.date_actabilite"
                              :label="actabilityTerm">
                    </sortable>
                    {{fromCard ? actabilityTerm : ''}}
                    <div class="deco"></div>
                  </th>
                  <th v-if="isAdmin && showColumn('created_on')" class="is-groupcols-3a">
                    <sortable @sort="sort('created_on', $event, sortBy)" :sort="sortBy.created_on"
                              label="Création"></sortable>
                    <div class="deco"></div>
                  </th>
                  <th class="has-text-centered"></th>
                </tr>
              </thead>
              <lot-row v-for="(lot, index) in items"
                       :id="'e' + lot.pk"
                       :key="lot.pk"
                       :source="lot"
                       :is-parking="isParking"
                       :index="index"
                       :currentPage="currentPage"
                       :columns="columns"
                       :multiselection="multiselection"
                       :total="items.length"
                       :class="{'has-status-bar--left has-status-bar--draft': scrollToEl === lot.pk}"
                       @deleteItem="deleteItem"
                       :selectedItems="selectedItems"
                       @selectItem="v => $emit('selectItem', v)"></lot-row>
              <tbody>
                <!-- <tr v-if="totalPage > 1 && nextPage">
                  <td colspan="10" class="has-text-center"><infinite-loading spinner="waveDots" @infinite="val => $emit('loadMore', val)"></infinite-loading></td>
                </tr> -->
                <tr class="empty empty--row" v-for="n in items.length < 5 ? 5 - items.length : 0 " :key="n"><td class="is-borderless"></td></tr>
              </tbody>
            </table>
          </table-h-scroll>
          <div class="is-border-top" v-if="totalPage > 1 && nextPage">
            <a class="button is-light is-fullwidth has-text-grey" @click="$emit('loadMore', fromClick)" v-if="!infiniteLoading">
              <span class="icon is-small is-size-6"><i class="fas fa-chevron-down"></i></span>
              <span class="is-size-6">Afficher la suite</span>
            </a>
            <div class="has-text-centered" v-else><img src="static/spinner2.svg" alt="spinner" style="height: 38px"></div>
          </div>
        </div>
      </div>
      <div v-if="(!items || !items.length) && !loading && !fromCard"
          class="is-border is-radius-large has-bg-white column has-text-centered">
        <div v-if="hasFilter">
          <span class="subtitle">Pas de résultat pour ces critères.</span>
          <br>
          <p class="is-margin-top"><a class="button is-primary" @click.prevent.stop="$emit('resetFilters')">Réinitialiser
            les filtres</a></p>
        </div>
        <span class="subtitle" v-else>Vous n'avez pas de stock visible. Veuillez vous rapprocher d'un administrateur.</span>
      </div>
      <div v-if="(!items || !items.length) && !loading && fromCard"
          class="is-border-top has-bg-white is-padding has-text-centered">
        <i class="subtitle">Pas de {{(isParking) ? 'parking' : 'lot'}}.</i>
      </div>
      <!-- <div :class="fromCard ? 'is-border-top' : 'is-border is-margin-bottom-xsmall'"
        class="columns is-gapless is-padding-left is-padding-right is-vcentered">
        <div class="column" v-if="!fromCard">
          <pagination :loading="loading"
                      @ChangePage="changePage"
                      :currentPage="currentPage"
                      :totalPage="totalPage"
                      :reverse="true"
          ></pagination>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
  import { DefaultValues, ColumnConf, OptionStatus, TableHeaderSticky } from '@/mixins'
  import { mapGetters, mapState } from 'vuex'
  import { debounce } from 'lodash'
  import LotRow from '../lot/LotRow'

  export default {
    name: 'StockLots',
    mixins: [DefaultValues, ColumnConf, OptionStatus, TableHeaderSticky],
    components: {
      LotRow
    },
    props: {
      sourceFilters: Object,
      sourceLots: Array,
      paramsList: Object,
      multiselection: {
        type: Boolean,
        default: false
      },
      fromCard: {
        type: Boolean,
        default: false
      },
      selectedItems: {
        type: Array,
        default: () => []
      },
      lotsStatus: {
        type: Array
      },
      isParking: {
        type: Boolean,
        default: undefined
      }
    },
    computed: {
      ...mapState(['scrollToEl', 'configs']),
      ...mapGetters([
        'currentUserPk', 'isAdmin', 'isExternal',
        'isDistributeurMode', 'displayRemuneration'
      ]),
      actabilityTerm () {
        if (!this.configs) return
        let term = {
          FRA: 'Actabilité',
          MAR: 'Titre foncier'
        }
        return term[this.configs.COUNTRY]
      },
      sortBy () {
        return this.paramsList.sortBy
      },
      currentPage () {
        return this.paramsList.currentPage
      },
      totalPage () {
        return this.paramsList.totalPage
      },
      loading () {
        return this.paramsList.loading
      },
      hasFilter () {
        return this.paramsList.hasFilter
      },
      nextPage () {
        return this.paramsList.nextPage
      },
      infiniteLoading () {
        return this.paramsList.infiniteLoading
      },
      profilAvailableStatus () {
        let status = []
        if (this.isAdmin) {
          status.push(this.statusData.draft)
        }
        status.push(this.statusData.available)
        status.push(this.statusData.optioned)
        if (this.isAdmin) {
          status.push(this.statusData.reserved)
          status.push(this.statusData.sold)
        }
        return status
      },
      columnsShow () {
        const columns = {}
        let programLotVue = ['ProgramVue', 'LotVue', 'ParkingVue'].includes(this.$route.name)
        if (!programLotVue) columns.program = {label: 'Programme'}
        if (!this.isExternal && this.isDistributeurMode && !programLotVue) {
          columns.promoteur_name = {label: 'Promoteur'}
        }
        if (!programLotVue) columns.zip_code = {label: 'Code Postal'}
        if (!programLotVue) columns.city = {label: 'Ville'}
        columns.nature = {label: 'Nature'}
        if (!this.isParking) {
          columns.surface = {label: 'Surface'}
          columns.floor = {label: 'Étage'}
          columns.exposures = {label: 'Orientation'}
          columns.parking = {label: 'Parking'}
          columns.rent = {label: 'Loyer HC'}
          columns.tax_dispositifs = {label: 'Dispositif'}
          columns.profitability = {label: 'Rentabilité'}
          columns.capped_profitability = {label: 'Rentabilité plafonnée'}
        }
        columns.date_livraison = {label: 'Livraison'}
        columns.date_actabilite = {label: this.actabilityTerm}
        if (this.isAdmin) {
          columns.created_on = {label: 'Création'}
        }
        return columns
      },
      columnsConfResource () {
        return 'lot-stock' + this.$route.name
      }
    },
    data () {
      return {
        lotFilters: [],
        items: [],
        service: this.$api.lotService,
        rowDetailLots: [],
        infiniteLoaderEnabled: true,
        fromClick: true
      }
    },
    watch: {
      sourceLots (v) {
        this.tickingSticky()
        this.items = v
      },
      lotsStatus (v) {
        this.lotFilters = v
      }
    },
    methods: {
      tagColor (value) {
        const COLORS = {
          'available': 'is-disponible',
          'optioned': 'is-optionne',
          'sold': 'is-acte',
          'draft': 'is-draft',
          'archived': 'is-draft',
          'reserved': 'is-reserve'
        }
        return COLORS[value]
      },
      bgColor (value) {
        const COLORS = {
          'available': 'has-bg-disponible',
          'optioned': 'has-bg-optionne',
          'sold': 'has-bg-acte',
          'draft': 'has-bg-draft',
          'archived': 'has-bg-draft',
          'reserved': 'has-bg-reserve'
        }
        return COLORS[value]
      },
      beforeGet () {
        if (this.query.program && typeof this.query.program === 'object') {
          this.query.program = this.query.program.pk
        }
        if (this.query.promoteur && typeof this.query.promoteur === 'object') {
          this.query.promoteur = this.query.promoteur.pk
        }
        if (Array.isArray(this.query.lot_type)) {
          const tmp = []
          this.query.lot_type.forEach(t => {
            tmp.push(t)
            tmp.push(t + '_duplex')
            tmp.push(t + '_bis')
          })
          this.query.lot_type = tmp
        }
      },
      sort (v, e, sortBy) {
        console.log(v)
        console.log(e)
        console.log(sortBy)
        this.$emit('sort', {v, e, sortBy})
      },
      changePage (v) {
        this.$scrollTo('#lots-tableau')
        this.$emit('changePage', v)
      },
      updateStatus: debounce(function () {
        this.$emit('updateLotStatusFilter', this.lotFilters)
      }, 600),
      toggleRowLot (idLot) {
        if (this.isRowLotOpen(idLot)) {
          let idx = this.rowDetailLots.findIndex(x => x === idLot)
          if (idx >= 0) this.rowDetailLots.splice(idx, 1)
        } else {
          this.rowDetailLots.push(idLot)
        }
      },
      isRowLotOpen (idLot) {
        return this.rowDetailLots.includes(idLot)
      },
      deleteItem (id) {
        return this.$swal({
          title: 'Suppression',
          text: 'Êtes vous sûr de vouloir supprimer ce lot ?',
          confirmButtonText: 'Supprimer'
        }).then(r => {
          if (r.value) {
            this.service.delete(id).then(r => {
              const i = this.items.findIndex(item => item.pk === id)
              if (i >= 0) {
                this.items.splice(i, 1)
                this.$notify({
                  type: 'is-success',
                  text: 'Élément supprimé.'
                })
              }
            }).catch(r => {
              this.$swal('Suppression impossible.', '')
            })
          }
        })
      }
    },
    created () {
      this.items = this.sourceLots
      this.lotFilters = this.lotsStatus
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/stock/StockLots.vue